import { useQuery, useQueryCache } from "react-query";
import axios from '../../axiosWrapper'
import { query } from '../../util/config'

export default function useZoomMeetings() {
  const cache = useQueryCache();
  const dashboard = cache.getQueryData(["meetings/zoom"]);
  return useQuery(
    ["meetings/zoom"],
    () => dashboard || axios.get('meetings/zoom'),
    query.initialQuery
  )
}
